import { ClientOnly } from "remix-utils/client-only";

import { ArtistDTO } from "~/types/artist";

import { ArtistImage } from "../ArtistImage/ArtistImage";
import { Button } from "../Button";
import {
  Drawer,
  DrawerTrigger,
  DrawerContent,
  DrawerTitle,
  DrawerFooter,
} from "../Drawer.client";
import { FollowersPill } from "../FollowersPill/FollowersPill";
import { cn } from "../utils";

interface Props {
  artist: ArtistDTO;
  isCurrentUser: boolean;
  isCommon: boolean;
}
export function UserArtistTile({ artist, isCurrentUser, isCommon }: Props) {
  return (
    <ClientOnly
      fallback={
        <ArtistImage
          alt={artist.name}
          url={artist.imageUrl}
          glow={isCommon}
          className={cn(
            "h-auto w-full",
            isCommon && "border-primary border",
            !isCurrentUser && !isCommon && "opacity-60",
          )}
        />
      }
    >
      {() => (
        <Drawer>
          <DrawerTrigger className="focus-visible:outline-none focus-visible:ring-0 focus-visible:border-0">
            <ArtistImage
              alt={artist.name}
              url={artist.imageUrl}
              glow={isCommon}
              className={cn(
                "h-auto w-full",
                isCommon && "border-primary border",
                !isCurrentUser && !isCommon && "opacity-60",
              )}
            />
          </DrawerTrigger>
          <DrawerContent className="h-5/6 items-center focus-visible:outline-none focus-visible:ring-0 focus-visible:border-0">
            <div className="p-4 gap-4 flex flex-col flex-1">
              <div className="relative">
                <ArtistImage
                  alt={artist.name}
                  url={artist.imageUrl}
                  className="w-full h-auto max-w-[400px]"
                />
                <FollowersPill
                  followers={artist.followers}
                  className="absolute left-3 bottom-3"
                />
              </div>
              <DrawerTitle className="text-white flex-1 text-base font-normal">
                {artist.name}
              </DrawerTitle>
              <DrawerFooter className="items-end mt-auto">
                <Button
                  href={artist.spotifyUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-fit"
                >
                  view on spotify
                </Button>
              </DrawerFooter>
            </div>
          </DrawerContent>
        </Drawer>
      )}
    </ClientOnly>
  );
}
